import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiEmailSendersResponse } from './types';

type GetArtistEmailSendersProps = {
  artistId: string;
};

export const getArtistEmailSenders = async ({ artistId }: GetArtistEmailSendersProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/emails/senders`;

  const response = await api.executeGetRequest<ObjectResponse<ApiEmailSendersResponse>>(url);

  return response.data;
};
